export const depositTicketConstants = {
  SET: 'DEPOSIT_TICKET_SET',
  DEPOSIT: 'DEPOSIT_TICKET_DEPOSIT',
  RESPONSE: 'DEPOSIT_TICKET_RESPONSE',
};

